import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  phoneCodes: null,
  newPhoneCode: null,
  newArticle: null,
  articles: null,
  languages: [{
    id: 'en',
    name: 'English'
  }, {
    id: 'es',
    name: 'Spanish'
  }, {
    id: 'fr',
    name: 'French'
  }],
  categories: [{
    id: 'free-calls',
    name: 'Free Calls',
    locale: 'en'
  }, {
    id: 'mobile-apps',
    name: 'Mobile Apps',
    locale: 'en'
  }, {
    id: 'calling-cards',
    name: 'International Calling',
    locale: 'en'
  }, {
    id: 'texting-sms',
    name: 'Texting/ SMS',
    locale: 'en'
  }, {
    id: 'voip',
    name: 'VoIP',
    locale: 'en'
  }, {
    id: 'llamadas-gratis',
    name: 'Llamadas Gratis',
    locale: 'es'
  }, {
    id: 'aplicaciones-moviles',
    name: 'Aplicaciones Móviles',
    locale: 'es'
  }, {
    id: 'llamadas-internacionales',
    name: 'Llamadas Internacionales',
    locale: 'es'
  }, {
    id: 'mensajes-de-texto--sms',
    name: 'SMS',
    locale: 'es'
  }, {
    id: 'appels-gratuits',
    name: 'Appels gratuits',
    locale: 'fr'
  }, {
    id: 'app-pour-mobiles',
    name: 'App pour mobiles',
    locale: 'fr'
  }, {
    id: 'appels-internationaux',
    name: 'Appels internationaux',
    locale: 'fr'
  }, {
    id: 'textossms',
    name: 'Textos/SMS',
    locale: 'fr'
  }, {
    id: 'voip',
    name: 'VoIP',
    locale: 'fr'
  }]
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/icg/index.js